import React, {Component} from 'react';
import {connect} from "react-redux";
import Page from './layout/Page';
import {SecondNav} from '../../components/layout/Navbars/header/secondNav/SecondNav';
import {FormattedMessage} from 'react-intl';
import {Routes} from '../../config';
import {Member} from '../../components/account/general/Member';
import {EditProfileForm} from '../../components/account/editProfile/EditProfileForm';
import {EditProfileSchema} from '../../helpers/schemas';
import {Formik} from "formik";
import {Section} from '../../components/layout/Section';
import {Grid} from '@material-ui/core';
import {requestUpdateProfile} from '../../store/actions/user';
import {displayNotification} from "../../store/actions/notification";
import {NOTIFICATION_ERROR,NOTIFICATION_SUCCESS} from "../../store/actions/types";
import {NO_PROPERTY_WAS_CHANGED} from "../../config/messages";
import {updateProfile} from "../../api/user";
import {userDetails} from "../../store/actions/user";
import {Filters} from '../../components/layout/Navbars/header/Filters';
import {history, store} from "../../store/store";
import { displayGlobalNotification } from "../../store/actions/globalNotification";
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';

class EditProfileComponent extends Component {
    constructor(props) {
        super(props);
        
        this.formRef = React.createRef();

        this.state = {
            openMessageModal: false,
            edited: false
        }
    }

    handleClose = () => {
        if (document.activeElement) {
            document.activeElement.blur();
        }
    
        this.setState({ openMessageModal: false });
    }

    submit = (data, {...props}) => {
        if (!this.state.edited) {
            store.dispatch(displayGlobalNotification(NOTIFICATION_ERROR, 'messages.no_property_was_changed'));
            return;
        }

        updateProfile(data).then((response) => {
            this.props.requestUpdateProfile(data, response);

            if (response.status === 200) {
                this.setState({
                    openMessageModal: true,
                    edited: false
                });
            }
        })
    };

    renderForm = (props) => {
        return <EditProfileForm
            userProfile={this.props.userProfile}
            formikProps={props}
            setFieldValueChange={this.setFieldValueChange}

        />
    }

    getEditProfileInitialValues = () => {
        const { userProfile } = this.props;

        return {
            email: userProfile.email || '',
            home_phone: userProfile.home_phone || '',
            mobile_phone: userProfile.mobile_phone || '',
            address_line_1: userProfile.address_line_1 || '',
            address_line_2: userProfile.address_line_2 || '',
            language_id: userProfile.language_id || '',
            all_communications: userProfile.all_communications || false,
            monthly_communications: userProfile.monthly_communications || false,

            country: userProfile.country || '',
            state: userProfile.states || '',

            city: userProfile.city || '',
            postal_code: userProfile.postal_code || '',

        }
    }

    setFieldValueChange = () => {
        this.setState({
            edited: true,
        });
    }

    render() {
        const {userProfile} = this.props;
        let { openMessageModal } = this.state;


        return <Page class="account edit-profile">
            <Filters />
            <SecondNav
                linkText={
                    <FormattedMessage id="pages.account.edit_profile.back_link_text"/>
                }
                link={Routes.ROUTE_MY_ACCOUNT}
                showSaveBtn={true}
                border={true}
                class="edit-profile"
                saveAction={() => this.formRef.submitForm()}
            />
            <Member userProfile={userProfile} class="my-account"/>

            <Section color="grey" className="edit-profile-form" id="profile-edit-form">

                <Grid container alignItems="center" justify="center">
                    <Grid item xs={12} sm={9} md={6}>
                        <div className="title">
                            <FormattedMessage id="components.account.editProfile.title"/>
                        </div>
                        <div className="sub-title">
                            <FormattedMessage id="components.account.editProfile.sub_title"/>
                        </div>
                        <Formik
                            initialValues={this.getEditProfileInitialValues()}
                            validationSchema={EditProfileSchema}
                            onSubmit={this.submit}
                            validateOnChange={true}
                            enableReinitialize={true}
                            innerRef={ref => (this.formRef = ref)}
                        >
                            {this.renderForm}
                        </Formik>
                    </Grid>
                </Grid>

                <Modal
                    className="add-new-credit-card-modal"
                    open={openMessageModal}
                    onClose={() => this.handleClose()}>
                    <div className="add-new-credit-card-modal-container">
                        <Grid container alignItems="center" justify="space-between" className="modal-title">
                            <Grid item>
                                <span>
                                    <FormattedMessage id="messages.profile_updated"/>
                                </span>
                            </Grid>
                            <Grid item>
                                <CloseIcon onClick={(e) => {e.preventDefault(); this.handleClose();}}/>
                            </Grid>
                        </Grid>
                        <div className="modal-body with-out-padding">
                            <div style = {{ marginBottom: '116px' }}>
                                <FormattedMessage id="messages.profile_updated_email_sent"/>
                            </div>
                        </div>
                    </div>
                </Modal>

            </Section>
            
        </Page>
    }
}

const mapStateToProps = (state) => ({
    userProfile: state.user.profile
})

const EditProfile = connect(mapStateToProps, {
    userDetails,
    displayNotification,
    requestUpdateProfile
})(EditProfileComponent);

export {EditProfile, EditProfileComponent};
